import { render, staticRenderFns } from "./ChatComposer.vue?vue&type=template&id=59fd996e&scoped=true"
import script from "./ChatComposer.vue?vue&type=script&lang=ts"
export * from "./ChatComposer.vue?vue&type=script&lang=ts"
import style0 from "./ChatComposer.vue?vue&type=style&index=0&id=59fd996e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fd996e",
  null
  
)

export default component.exports